<template>
	<span class="label-circle card-status" v-if="item.is_completed || item.is_started">
		<span class="label-circle-inner">
			<i class="block tbb-icon-2x" :class="statusIcon"></i>
			<span class="block font-medium">{{ statusText }}</span>
		</span>
	</span>
</template>

<script>
	module.exports = {
		props: ['item'],

		data() {
			return {
			}

		},

		computed: {
			statusText() {
				if(this.item.is_completed) {
					return 'completed';
				}

				if(this.item.is_started) {
					return 'in progress';
				}

				return '';
			},

			statusIcon() {
				if(this.item.is_completed) {
					return 'tbb-icon-check';
				}

				if(this.item.is_started) {
					return 'tbb-icon-ellipsis-h';
				}

				return '';
			}
		},

		methods: {}

	}
</script>
